<div class="no-results-container">
    <img class="no-results-img" width="140" height="140" alt="no_results" src="assets/img/no-results.svg">
    <h2 class="no-results-title">{{ 'NO_RESULTS.TITLE' | translate }}</h2>
    <div class="no-results-row1">
        <span>{{ 'NO_RESULTS.SUBTITLE' | translate }}</span>
    </div>
    <div class="no-results-row2">
        <span>{{ 'NO_RESULTS.INSTRUCTIONS' | translate }}</span>
    </div>
</div>